// MARK: - Log Actions
export const LogAction = {
    clicked: "clicked"
};

// MARK: - Log Elements
export const LogElements = {
    /*
        AUTHENTICATION ELEMENTS
     */
    
    /*
        Buttons
     */
    sampleButton: "Sample Button",
    showCompletedButton: "Show Completed Button",
    enrollPatientButton: "Enroll Patient button",
    patientNameDropdown: "Patient Name dropdown",
    selectProgramDropdown: "Select Program dropdown",
    devicesDropdown: "Devices dropdown",
    contentDropdown: "Content dropdown",
    updateButton: "Update button",
    gridEllipsesButton: "Grid ellipses button",
    /*
        AUTHENTICATION ELEMENTS
     */
    loginButton: "Login button",
    forgotPasswordButton: "Forgot Password Button",
    continueToLoginButton: "Continue to Login Button",
    
    /*
        SIDEBAR NAVIGATION ELEMENTS
     */
    sidebarDashboard: "Sidebar Dashboard",
    sidebarEnrollment: "Sidebar Enrollment",
    sidebarAppointments: "Sidebar Appointments",
    sidebarTasks: "Sidebar Tasks",
    sidebarBilling: "Sidebar Billing",
    sidebarOrganization: "Sidebar Organization",
    sidebarHierarchy: "Sidebar Hierarchy",
    sidebarEhrAccounts: "Sidebar EHR Accounts",
    sidebarAccounts: "Sidebar Accounts",
    sidebarRoles: "Sidebar Roles",
    sidebarReferenceCode: "Sidebar Reference Code",
    sidebarHub: "Sidebar Hub",
    sidebarDevices: "Sidebar Devices",
    sidebarDeviceRegistry: "Sidebar Device Registry",
    sidebarContent: "Sidebar Content",
    sidebarQuestionnaire: "Sidebar Questionnaire",
    sidebarCareProgram: "Sidebar Care Program",
    sidebarPatientMessages: "Sidebar Patient Messages",
    sidebarStaffMessages: "Sidebar Staff Messages",
    sidebarPatientReports: "Sidebar Patient Reports",
    
    /*
        PATIENT MANAGEMENT ELEMENTS
     */
    dischargeButton: "Discharge Button",
    
    /*
        ACCOUNT MANAGEMENT ELEMENTS
     */
    deactivateButton: "Deactivate Button",
    reactivateButton: "Reactivate Button",
    
    /*
        USER PROFILE ELEMENTS
     */
    logoutButton: "Logout Button",
    saveButton: "Save button",
    manageAccountButton: "Manage Account button",
    preferencesButton: "Preferences button",
    changePasswordButton: "Change Password button",
    securityActivityButton: "Security Activity button",
    manufacturerInformationButton: "Manufacturer Information button",
    
    /*
        Misc
     */
    notificationOverlay: "Notification Overlay"

};

export function formatLogMessage(element, action, customMessage = null) {
    const baseMessage = `${element} ${action}`;
    if (customMessage) {
        return `${baseMessage} (${customMessage})`;
    }
    return baseMessage;
}
